import React from 'react';
import classnames from 'classnames';
import s from './ProgressBar.scss';
var ProgressBar = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.percentage, percentage = _c === void 0 ? 0 : _c;
    return (React.createElement("div", { className: classnames(s['root'], className) },
        React.createElement("div", { className: s['bar'], style: { width: Math.max(0, Math.min(100, percentage)) + "%" } })));
};
export default ProgressBar;
//# sourceMappingURL=ProgressBar.js.map